export enum RequestForParticipantAdmissionStatusValues {
  NotMarked = "NOT_MARKED",
  Admitted = "ADMITTED",
  Rejected = "REJECTED",
}

export type RequestForParticipantAdmissionStatus =
  RequestForParticipantAdmissionStatusValues;
